import { createBrowserRouter, Navigate, type RouteObject } from "react-router-dom";
import { LoginPage } from "./pages/Login";
import { DashboardPage } from "./pages/Dashboard";
import { ItemsPage } from "./pages/Items";
import { ItemNewPage } from "./pages/ItemNew";
import { PartiesPage } from "./pages/Parties";
import { CompaniesPage } from "./pages/Companies";
import { CompanyAccountPage } from "./pages/CompanyAccount";
import { LocationsPage } from "./pages/Locations";
import { UsersPage } from "./pages/Users";
import { RecipesPage } from "./pages/Recipes";
import { InventoryPage } from "./pages/Inventory";
import { OrdersPage } from "./pages/Orders";
import { OrderCostAnalysisPage } from "./pages/OrderCostAnalysis";
import { MrpReportPrintPage } from "./pages/MrpReportPrint";
import { OrderNewPage } from "./pages/OrderNew";
import { ProductionPage } from "./pages/Production";
import { ConsumptionPage } from "./pages/Consumption";
import { ProductionParamReportPage } from "./pages/ProductionParamReport";
import { ProductionReportPrintPage } from "./pages/ProductionReportPrint";
import { PurchaseRequestPrintPage } from "./pages/PurchaseRequestPrint";
import { PurchaseOrderFormPrintPage } from "./pages/PurchaseOrderFormPrint";
import { GoodsReceiptPrintPage } from "./pages/GoodsReceiptPrint";
import { StockCountPrintPage } from "./pages/StockCountPrint";
import { ShiftPlanPrintPage } from "./pages/ShiftPlanPrint";
import { OrgChartPrintPage } from "./pages/OrgChartPrint";
import { DeliveryPlanPrintPage } from "./pages/DeliveryPlanPrint";
import { StockReportPrintPage } from "./pages/StockReportPrint";
import { QcPage } from "./pages/Qc";
import { MaintenancePage } from "./pages/Maintenance";
import { DepoYonetimiPage } from "./pages/DepoYonetimi";
import { FormsPage } from "./pages/Forms";
import { FormsDashboard, FormsIndexRedirect } from "./pages/FormsDashboard";
import { SuperAdminGate } from "./components/SuperAdminGate";
import { CertificatesPage } from "./pages/Certificates";
import { ShipmentsPage } from "./pages/Shipments";
import { MrpPage } from "./pages/Mrp";
import { PurchasingPage } from "./pages/Purchasing";
import { SettingsPage } from "./pages/Settings";
import ProjectsPage from "./pages/Projects";
import PersonnelPage from "./pages/Personnel";
import { BulkOvertimePage } from "./pages/BulkOvertime";
import { BulkAbsencePage } from "./pages/BulkAbsence";
import { AppShell } from "./components/app-shell/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PageGate } from "./components/PageGate";

/**
 * KABUK İÇİ ROTALAR — sekme motorunun da kullandığı TEK liste.
 *
 * `createBrowserRouter` bu diziyi AppShell'in çocukları olarak alır; sekme motoru
 * (components/app-shell/TabViews.tsx) aynı diziyi `matchRoutes(SHELL_ROUTES, tab.path)`
 * ile HER SEKME İÇİN ayrı ayrı çözer. İki ayrı liste tutulsaydı yeni bir sayfa
 * eklendiğinde biri güncellenip diğeri unutulur ve o sayfa sekmede BOŞ görünürdü.
 */
export const SHELL_ROUTES: RouteObject[] = [
  { path: "/", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard", element: <PageGate pageKey="dashboard"><DashboardPage /></PageGate> },
  { path: "/items", element: <Navigate to="/items/stock" replace /> },
  { path: "/items/:kind", element: <PageGate pageKey="items"><ItemsPage /></PageGate> },
  // Yeni kart artık ÇEKMECE değil, uygulama içi SEKME (form yarım kalmadan başka sayfaya bakılabilsin).
  { path: "/items/:kind/yeni", element: <PageGate pageKey="items"><ItemNewPage /></PageGate> },
  { path: "/companies", element: <PageGate pageKey="companies"><CompaniesPage /></PageGate> },
  // Cari hesap ekstresi — uygulama içi SEKME (uzun belge; filtre/kaydırma kaybolmasın).
  { path: "/companies/:id/hesap", element: <PageGate pageKey="companies"><CompanyAccountPage /></PageGate> },
  { path: "/parties", element: <Navigate to="/parties/suppliers" replace /> },
  { path: "/parties/:kind", element: <PageGate pageKey="parties"><PartiesPage /></PageGate> },
  { path: "/locations", element: <PageGate pageKey="locations"><LocationsPage /></PageGate> },
  { path: "/recipes", element: <PageGate pageKey="recipes"><RecipesPage /></PageGate> },
  { path: "/inventory", element: <PageGate pageKey="inventory"><InventoryPage /></PageGate> },
  { path: "/orders", element: <PageGate pageKey="orders"><OrdersPage /></PageGate> },
  // Yeni siparis artik CEKMECE degil, uygulama ici SEKME (uzun form yarim kalmasin).
  { path: "/orders/yeni", element: <PageGate pageKey="orders"><OrderNewPage /></PageGate> },
  /* Mali analiz: sayfa erişimi + AYRICA süper-admin şartı (maliyet/kâr + reçete kırılımı mahrem).
     Arayüz gizlemek yetki değildir — uç (`order.costAnalysis`) da süper-admin arıyor. */
  { path: "/orders/:id/mali-analiz", element: <PageGate pageKey="orders"><SuperAdminGate redirectTo="/orders"><OrderCostAnalysisPage /></SuperAdminGate></PageGate> },
  { path: "/production", element: <PageGate pageKey="production"><ProductionPage /></PageGate> },
  { path: "/production/parametre-raporu", element: <PageGate pageKey="production"><ProductionParamReportPage /></PageGate> },
  { path: "/tuketim-beyani", element: <PageGate pageKey="tuketim-beyani"><ConsumptionPage /></PageGate> },
  { path: "/qc", element: <PageGate pageKey="qc"><QcPage /></PageGate> },
  { path: "/maintenance", element: <PageGate pageKey="maintenance"><MaintenancePage /></PageGate> },
  { path: "/depo-yonetimi", element: <PageGate pageKey="depo-yonetimi"><DepoYonetimiPage /></PageGate> },
  { path: "/projeler", element: <PageGate pageKey="projects"><ProjectsPage /></PageGate> },
  { path: "/personel", element: <PageGate pageKey="personel"><PersonnelPage /></PageGate> },
  // Toplu giriş ekranları artık ÇEKMECE değil, uygulama içi SEKME: 60 kişilik liste
  // doldurulurken vardiya planına/puantaja bakıp geri dönülebilsin (çekmecede giriş silinirdi).
  { path: "/personel/mesai", element: <PageGate pageKey="personel"><BulkOvertimePage /></PageGate> },
  { path: "/personel/devamsizlik", element: <PageGate pageKey="personel"><BulkAbsencePage /></PageGate> },
  { path: "/formlar", element: <PageGate pageKey="forms"><FormsIndexRedirect /></PageGate> },
  { path: "/formlar/panel", element: <PageGate pageKey="forms"><SuperAdminGate><FormsDashboard /></SuperAdminGate></PageGate> },
  { path: "/formlar/liste", element: <PageGate pageKey="forms"><FormsPage /></PageGate> },
  { path: "/shipments", element: <PageGate pageKey="shipments"><ShipmentsPage /></PageGate> },
  { path: "/mrp", element: <PageGate pageKey="mrp"><MrpPage /></PageGate> },
  { path: "/purchasing", element: <PageGate pageKey="purchasing"><PurchasingPage /></PageGate> },
  { path: "/certificates", element: <PageGate pageKey="certificates"><CertificatesPage /></PageGate> },
  { path: "/users", element: <PageGate pageKey="users"><UsersPage /></PageGate> },
  { path: "/settings", element: <PageGate pageKey="settings"><SettingsPage /></PageGate> },
  { path: "*", element: <Navigate to="/dashboard" replace /> },
];

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      // Yazdırılabilir üretim raporu — uygulama kabuğu (sidebar) DIŞINDA, yeni sekmede A4.
      { path: "/print/uretim-raporu", element: <ProductionReportPrintPage /> },
      // Yazdırılabilir satın alma talebi (A4) — sidebar dışında, yeni sekmede.
      { path: "/print/satinalma-talebi", element: <PurchaseRequestPrintPage /> },
      // Kurumsal satın alma sipariş formu (A4) — onaydan sonra tedarikçiye gönderilen resmi belge.
      { path: "/print/siparis-formu", element: <PurchaseOrderFormPrintPage /> },
      // Mal kabul tutanağı (A4) — teslim alınan kalemler + teslim eden/alan imzaları.
      { path: "/print/mal-kabul-tutanagi", element: <GoodsReceiptPrintPage /> },
      // Stok sayım tutanağı (A4) — sayan/kontrol/onay imzalı; ekranla AYNI ucu okur.
      { path: "/print/sayim-tutanagi", element: <StockCountPrintPage /> },
      // Haftalık vardiya programı (A4) — panonun kendisi yazdırılamıyor (ekran widget'ı,
      // 2000px+ genişlik); bu belge akan yerleşimle sayfaya sığar ve metin vektör kalır.
      { path: "/print/vardiya-plani", element: <ShiftPlanPrintPage /> },
      // Organizasyon şeması (A4 dikey) — ekrandaki SVG tek parça olduğu için sayfalara
      // bölünemiyor; bu belge girintili hiyerarşi olarak akar ve kaç sayfa sürerse sürsün
      // yazı tam boyda kalır. Sıra ekrandakiyle aynı (orgLayout.ts).
      { path: "/print/organizasyon-semasi", element: <OrgChartPrintPage /> },
      // Teslimat planı (A4) — süzgeçlenmiş siparişler teslim tarihine göre gün gün. Süzgeçler
      // query string ile TOHUMLANIR ama bu ekrandan değiştirilebilir (rapor kendi state'ini tutar).
      { path: "/print/teslimat-plani", element: <DeliveryPlanPrintPage /> },
      // MRP raporu (A4) — MRP ekranından SEÇİLEN siparişler `?orderIds=a,b,c` ile gelir.
      // Rapor sipariş listesini, sipariş bazında ve TOPLU eksikleri basar; toplu tablo
      // ayrı bir MRP koşusudur (stok paylaşıldığı için toplamların toplamı değildir).
      { path: "/print/mrp-raporu", element: <MrpReportPrintPage /> },
      // Envanter raporu (A4 yatay) — ürün bazında / lot bazında; ekran + baskı + Excel AYNI yanıttan.
      // Stok/Lotlar > "Stok Raporu" açar; URL süzgeçleri yalnız TOHUMLAR (DeliveryPlanPrint kalıbı).
      { path: "/print/stok-raporu", element: <StockReportPrintPage /> },
      { element: <AppShell />, children: SHELL_ROUTES },
    ],
  },
]);
